import ptBR from "./pt-BR";
import en from "./en";

export default {
  "pt-BR": ptBR,
  en: en,
};



// WEBPACK FOOTER //
// ./src/lang/index.js